/**
 * Practice companies (2026-10-30): a demo-flagged company a prospect clicks through on their own,
 * built by scripts/demo-trident-practice. profiles.isPracticeAccount only decides what the person
 * SEES (a banner, a tag on their Feedback). Containment (who can see their jobs and people, and that
 * nothing is emailed) rests on isDemoAccount, which is server-owned (src/lib/demoAccounts.ts), so
 * nothing here grants anything.
 */
export function isPracticeProfile(profile: object | null | undefined): boolean {
  return (profile as { isPracticeAccount?: unknown } | null | undefined)?.isPracticeAccount === true;
}

/** "[Practice account: Trident EMS] " in front of a Feedback title so the super admin sees where it came from. */
export function practiceFeedbackPrefix(profile: object | null | undefined): string {
  if (!isPracticeProfile(profile)) return '';
  const label = (profile as { practiceLabel?: unknown }).practiceLabel;
  const name = typeof label === 'string' && label.trim() ? label.trim().slice(0, 60) : 'practice company';
  return `[Practice account: ${name}] `;
}
